
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'add_alert': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 21',
    data: '<path pid="0" d="M7.01 19.01A1.989 1.989 0 0 0 9 21a1.989 1.989 0 0 0 1.99-1.99zm8.87-4.19V9a6.873 6.873 0 0 0-5.29-6.69v-.72A1.588 1.588 0 0 0 9 0a1.588 1.588 0 0 0-1.59 1.59v.72A6.873 6.873 0 0 0 2.12 9v5.82L0 16.94V18h18v-1.06l-2.12-2.12zM13 11.01h-3v3H8v-3H5V9h3V6h2v3h3v2.01z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
